/* =============================================================================
   bc-search-snize-cards.js
   Replaces Snize's own product-card markup on /pages/search-results-page
   with our own bc-pcard component (same one collections use) instead of
   trying to restyle Snize's card — their DOM only exposes title/price/
   image/url, not variants, product_type, or availability, so a real
   Add-to-Cart button isn't possible without more data. Each visible result
   is looked up via Shopify's /products/{handle}.js AJAX endpoint and
   re-rendered with the same markup snippets/bc-product-card.liquid outputs,
   reusing assets/bc-collection-page.css (loaded globally in theme.liquid)
   and the existing data-bc-atc / bc-atc.js cart-add flow — no new cart
   logic needed, that listener is already document-wide.
   ============================================================================= */
(function () {
  'use strict';

  var RESULTS_SELECTOR = '.snize-search-results-content';
  var FREE_SHIP_THRESHOLD_CENTS = (window.bcFreeShippingThreshold || 0) * 100;
  var productCache = {};

  function escapeHTML(s) {
    var d = document.createElement('div');
    d.textContent = s || '';
    return d.innerHTML;
  }

  function formatMoney(cents) {
    var currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD';
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en', {
        style: 'currency',
        currency: currency,
        minimumFractionDigits: 2
      }).format(cents / 100);
    } catch (e) {
      return '$' + (cents / 100).toFixed(2);
    }
  }

  function getHandle(url) {
    var m = (url || '').match(/\/products\/([^/?#]+)/);
    return m ? m[1] : null;
  }

  function fetchProduct(handle) {
    if (!productCache[handle]) {
      productCache[handle] = fetch('/products/' + handle + '.js')
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; });
    }
    return productCache[handle];
  }

  /* Figma node 17:9257 — same path as bc-product-card.liquid's inline SVG */
  var SHIP_ICON =
    '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 15 10.5039" fill="none" aria-hidden="true">' +
    '<path d="M14.9637 3.8125L14.0887 1.625C14.0145 1.43992 13.8864 1.28139 13.7211 1.16996C13.5557 1.05852 13.3607 0.999314 13.1613 1H11V0.5C11 0.367392 10.9473 0.240215 10.8536 0.146447C10.7598 0.0526785 10.6326 0 10.5 0H1C0.734784 0 0.48043 0.105357 0.292893 0.292893C0.105357 0.48043 0 0.734784 0 1V8C0 8.26522 0.105357 8.51957 0.292893 8.70711C0.48043 8.89464 0.734784 9 1 9H2.0625C2.17265 9.43021 2.42285 9.81152 2.77366 10.0838C3.12446 10.3561 3.55591 10.5039 4 10.5039C4.44409 10.5039 4.87554 10.3561 5.22635 10.0838C5.57715 9.81152 5.82735 9.43021 5.9375 9H9.0625C9.17265 9.43021 9.42285 9.81152 9.77365 10.0838C10.1245 10.3561 10.5559 10.5039 11 10.5039C11.4441 10.5039 11.8755 10.3561 12.2263 10.0838C12.5771 9.81152 12.8273 9.43021 12.9375 9H14C14.2652 9 14.5196 8.89464 14.7071 8.70711C14.8946 8.51957 15 8.26522 15 8V4C15.0002 3.93574 14.9879 3.87206 14.9637 3.8125ZM11 2H13.1613L13.7612 3.5H11V2ZM1 1H10V5H1V1ZM4 9.5C3.80222 9.5 3.60888 9.44135 3.44443 9.33147C3.27998 9.22159 3.15181 9.06541 3.07612 8.88268C3.00043 8.69996 2.98063 8.49889 3.01921 8.30491C3.0578 8.11093 3.15304 7.93275 3.29289 7.79289C3.43275 7.65304 3.61093 7.5578 3.80491 7.51921C3.99889 7.48063 4.19996 7.50043 4.38268 7.57612C4.56541 7.65181 4.72159 7.77998 4.83147 7.94443C4.94135 8.10888 5 8.30222 5 8.5C5 8.76522 4.89464 9.01957 4.70711 9.20711C4.51957 9.39464 4.26522 9.5 4 9.5ZM9.0625 8H5.9375C5.82735 7.56979 5.57715 7.18848 5.22635 6.91618C4.87554 6.64388 4.44409 6.49608 4 6.49608C3.55591 6.49608 3.12446 6.64388 2.77366 6.91618C2.42285 7.18848 2.17265 7.56979 2.0625 8H1V6H10V6.76937C9.77008 6.90227 9.56883 7.07948 9.4079 7.29072C9.24697 7.50197 9.12957 7.74305 9.0625 8ZM11 9.5C10.8022 9.5 10.6089 9.44135 10.4444 9.33147C10.28 9.22159 10.1518 9.06541 10.0761 8.88268C10.0004 8.69996 9.98063 8.49889 10.0192 8.30491C10.0578 8.11093 10.153 7.93275 10.2929 7.79289C10.4327 7.65304 10.6109 7.5578 10.8049 7.51921C10.9989 7.48063 11.2 7.50043 11.3827 7.57612C11.5654 7.65181 11.7216 7.77998 11.8315 7.94443C11.9414 8.10888 12 8.30222 12 8.5C12 8.76522 11.8946 9.01957 11.7071 9.20711C11.5196 9.39464 11.2652 9.5 11 9.5ZM14 8H12.9375C12.826 7.57084 12.5754 7.19077 12.2247 6.91934C11.8741 6.6479 11.4434 6.50042 11 6.5V4.5H14V8Z" fill="white"/>' +
    '</svg>';

  var REVIEW_ICON =
    '<svg width="13" height="13" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">' +
    '<path d="M14 1H2C1.44772 1 1 1.44772 1 2V10C1 10.5523 1.44772 11 2 11H4.5L8 15L11.5 11H14C14.5523 11 15 10.5523 15 10V2C15 1.44772 14.5523 1 14 1Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>' +
    '<path d="M5 5.5H11M5 7.5H9" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg>';

  /* "Snippet" for the badge cluster that sits on top of the product photo
     (discount % + free-shipping pill) — split out from buildCardHTML so
     the card's own markup and the badges' markup are two separate,
     independently-readable template functions, same idea as a Liquid
     {% render %} snippet, just as a JS function since these cards can
     only be built client-side (Snize's results only exist after an async
     AJAX fetch, long after Liquid has already rendered and finished). */
  function buildBadgesHTML(variant, onSale, discountPct, showFreeShip) {
    var html = '';
    if (onSale && discountPct > 0) {
      html += '<span class="bc-pcard__discount" aria-label="' + discountPct + '% off">-' + discountPct + '%</span>';
    }
    if (showFreeShip) {
      html += '<span class="bc-pcard__ship-badge">' + SHIP_ICON + 'Free Shipping</span>';
    }
    return html;
  }

  function buildCardHTML(product) {
    var variant = product.variants.filter(function (v) { return v.available; })[0] || product.variants[0];
    var onSale = variant.compare_at_price && parseFloat(variant.compare_at_price) > parseFloat(variant.price);
    var discountPct = onSale
      ? Math.round(((variant.compare_at_price - variant.price) / variant.compare_at_price) * 100)
      : 0;
    var showFreeShip = FREE_SHIP_THRESHOLD_CENTS > 0 && variant.price >= FREE_SHIP_THRESHOLD_CENTS;
    var img = product.featured_image || (product.images && product.images[0]) || '';
    var imgUrl = img ? img.replace(/(\.[a-z]+)(\?.*)?$/i, '_600x$1') : '';
    /* Second-image-on-hover, matching snippets/bc-product-card.liquid's
       own mechanism exactly: product.images[1] (this AJAX endpoint's
       equivalent of product.media[1] there), only when a second image
       actually exists — same "" .bc-pcard__media--has-hover class the
       CSS's hover transition keys off. */
    var hoverImgRaw = (product.images && product.images.length > 1) ? product.images[1] : null;
    var hoverImgUrl = hoverImgRaw ? hoverImgRaw.replace(/(\.[a-z]+)(\?.*)?$/i, '_600x$1') : '';
    var url = '/products/' + product.handle;
    var title = escapeHTML(product.title);

    var badgesHTML = buildBadgesHTML(variant, onSale, discountPct, showFreeShip);

    var priceHTML = onSale
      ? '<span class="bc-pcard__price bc-pcard__price--sale">' + formatMoney(variant.price) + '</span>' +
        '<s class="bc-pcard__price bc-pcard__price--compare">' + formatMoney(variant.compare_at_price) + '</s>'
      : '<span class="bc-pcard__price bc-pcard__price--regular">' + formatMoney(variant.price) + '</span>';

    var skuHTML = variant.sku ? '<span class="bc-pcard__sku">SKU: ' + escapeHTML(variant.sku) + '</span>' : '';
    var vendorHTML = product.type ? '<span class="bc-pcard__vendor">' + escapeHTML(product.type) + '</span>' : '';

    /* No rating here — Shopify's /products/{handle}.js endpoint doesn't
       expose metafields, so the Judge.me rating this card would otherwise
       read isn't available client-side. Falls back to the same "leave a
       review" stub bc-product-card.liquid itself uses when a product has
       no rating yet. */
    var ratingHTML =
      '<div class="bc-pcard__rating"><a href="' + url + '#judgeme_product_reviews" class="bc-pcard__review-cta" aria-label="Leave a review">' +
      REVIEW_ICON + '<span>Leave a review</span></a></div>';

    var atcHTML;
    if (!variant.available) {
      atcHTML = '<span class="bc-pcard__atc bc-pcard__atc--sold-out">Sold out</span>';
    } else if (product.variants.length === 1) {
      atcHTML =
        '<form method="post" action="/cart/add" accept-charset="UTF-8" data-bc-atc>' +
        '<input type="hidden" name="form_type" value="product">' +
        '<input type="hidden" name="utf8" value="&#10003;">' +
        '<input type="hidden" name="id" value="' + variant.id + '">' +
        '<input type="hidden" name="quantity" value="1">' +
        '<button type="submit" name="add" class="bc-pcard__atc"><span>Add to Cart</span></button>' +
        '</form>';
    } else {
      atcHTML = '<a href="' + url + '" class="bc-pcard__atc">Add to Cart</a>';
    }

    return (
      '<div class="bc-pcard">' +
      '<a href="' + url + '" class="bc-pcard__media-wrap" aria-label="' + title + '" tabindex="-1">' +
      '<div class="bc-pcard__media' + (hoverImgUrl ? ' bc-pcard__media--has-hover' : '') + '">' +
      (imgUrl ? '<img class="bc-pcard__img bc-pcard__img--primary" src="' + imgUrl + '" alt="' + title + '" loading="lazy">' : '') +
      (hoverImgUrl ? '<img class="bc-pcard__img bc-pcard__img--hover" src="' + hoverImgUrl + '" alt="' + title + '" loading="lazy">' : '') +
      badgesHTML +
      '</div></a>' +
      '<div class="bc-pcard__content">' +
      vendorHTML +
      '<h3 class="bc-pcard__title"><a href="' + url + '" class="bc-pcard__title-link">' + title + '</a></h3>' +
      ratingHTML +
      '<div class="bc-pcard__price-block"><div class="bc-pcard__price-row">' + priceHTML + '</div></div>' +
      skuHTML +
      '</div>' +
      '<div class="bc-pcard__footer">' + atcHTML + '</div>' +
      '</div>'
    );
  }

  /* Returns true when the active Snize tab is Products — the only tab where
     the result list should be laid out as a product card grid. Categories and
     Pages tabs render row-based layouts that must NOT receive grid classes. */
  function isProductsTab() {
    var root = document.querySelector('#snize_results');
    return !root ||
      (!root.classList.contains('snize-tab-selected-categories') &&
       !root.classList.contains('snize-tab-selected-pages'));
  }

  function transform() {
    var results = document.querySelector(RESULTS_SELECTOR);
    if (!results) return;

    if (isProductsTab()) {
      /* Products tab: ensure grid classes are present (idempotent). */
      if (!results.classList.contains('grid')) {
        results.classList.add('grid', 'product-grid', 'grid--2-col-tablet-down', 'grid--3-col-desktop');
      }
    } else {
      /* Categories / Pages tab: strip any stale product-grid classes left
         from a previous Products-tab render. The list must be display:block
         so rows stack vertically; CSS rules on #snize_results.snize-tab-
         selected-categories provide the rest of the layout. */
      results.classList.remove('grid', 'product-grid', 'grid--2-col-tablet-down', 'grid--3-col-desktop');
    }

    /* Snize re-applies its own inline width (e.g. "31.39%") on window
       resize to keep its 3-per-row math working — that fights
       grid__item's CSS width from bc-collection-page.css every time the
       viewport changes, not just on first render, so already-transformed
       items get swept too, not just new ones. Cheap on an interval: a
       card either has no style attribute (skip) or does (strip it). */
    results.querySelectorAll('.snize-product[data-bc-transformed][style]').forEach(function (li) {
      li.removeAttribute('style');
    });

    var items = results.querySelectorAll('.snize-product:not([data-bc-transformed])');
    if (!items.length) return;

    /* Snize paints its own card markup the instant a re-render lands (a
       price tweak, a filter, a sort, a page change), and our swap can only
       happen after that — plus one /products/{handle}.js round trip per
       card. That showed as Snize's default layout flashing up and then
       jumping to ours. The grid is held at opacity:0 (layout height kept,
       so nothing reflows) from the moment untransformed items appear until
       every card in this batch has been rewritten. `renderToken` makes a
       late batch's Promise.all unable to reveal a newer one that's still
       in flight, and holdResults arms a 3s failsafe so a hung fetch can
       never leave the grid invisible. */
    renderToken++;
    var token = renderToken;
    holdResults(results);

    var pending = [];
    items.forEach(function (li) {
      /* Marked synchronously (before the fetch resolves) so the
         MutationObserver's re-scan below — triggered by our own writes —
         doesn't refetch/re-render the same item in a loop. Marked even
         when there's no handle to look up: an item we can't rebuild is
         still an item we're done with, and leaving it unmarked would make
         holdIfUntransformed() re-hide the whole grid on every subsequent
         mutation. */
      li.setAttribute('data-bc-transformed', 'true');
      li.classList.add('grid__item');
      li.removeAttribute('style');

      var link = li.querySelector('a.snize-view-link');
      var handle = link && getHandle(link.getAttribute('href'));
      if (!handle) return;

      pending.push(fetchProduct(handle).then(function (product) {
        if (product) li.innerHTML = buildCardHTML(product);
      }));
    });

    Promise.all(pending).then(function () {
      if (token === renderToken) releaseResults(results);
    });
  }

  /* ── Results-grid reveal gate ─────────────────────────────────────────── */
  var renderToken = 0;
  var revealTimer = null;

  function holdResults(results) {
    if (!results.hasAttribute('data-bc-pending')) {
      results.setAttribute('data-bc-pending', '');
    }
    clearTimeout(revealTimer);
    revealTimer = setTimeout(function () {
      results.removeAttribute('data-bc-pending');
    }, 3000);
  }

  function releaseResults(results) {
    clearTimeout(revealTimer);
    results.removeAttribute('data-bc-pending');
  }

  /* ── Price slider geometry ────────────────────────────────────────────── */
  /* Snize sizes .slider-container from an inline px width it measures once,
     and positions both thumbs and the progress bar in px against that same
     stale number. bc-search-snize.css stretches the container to the real
     column width, which left those inline positions pointing past the end
     of the track — live, the max thumb sat at left:271px in a 280px track
     and hung 11px into the product grid. Recomputed here from the values
     Snize itself stores (hidden input "min,max"; absolute bounds from its
     own tick scale) against the track's live width. Skipped while a thumb
     is being dragged, since Snize owns `left` during the gesture and
     commits a new value — and a fresh render — when it ends. */
  var sliderDragging = false;

  function inSlider(node) {
    return !!(node && node.closest && node.closest('.snize-price-range-slider'));
  }

  document.addEventListener('mousedown', function (e) { if (inSlider(e.target)) sliderDragging = true; }, true);
  document.addEventListener('touchstart', function (e) { if (inSlider(e.target)) sliderDragging = true; }, true);
  document.addEventListener('mouseup', function () { sliderDragging = false; }, true);
  document.addEventListener('touchend', function () { sliderDragging = false; }, true);

  /* Prices reach us in whatever the storefront's locale formats them as —
     "$140", "139.99" and "139,99" all show up on this page — so a comma is
     only treated as a decimal point when it's followed by one or two
     trailing digits ("139,99"), and as a thousands separator otherwise
     ("1,234"). */
  function numberFrom(text) {
    var t = String(text == null ? '' : text).replace(/[^0-9.,]/g, '');
    if (/,\d{1,2}$/.test(t)) {
      t = t.replace(/\./g, '').replace(',', '.');
    } else {
      t = t.replace(/,/g, '');
    }
    return parseFloat(t);
  }

  function fixPriceSliderGeometry() {
    if (sliderDragging) return;

    document.querySelectorAll('.snize-price-range-slider').forEach(function (slider) {
      var back = slider.querySelector('.back-bar');
      var low = slider.querySelector('.pointer.low');
      var high = slider.querySelector('.pointer.high');
      var selected = slider.querySelector('.selected-bar');
      var hidden = slider.querySelector('input.snize-range-slider');
      var ticks = slider.querySelectorAll('.scale ins');
      if (!back || !low || !high || !selected || !hidden || ticks.length < 2) return;

      var absMin = numberFrom(ticks[0].textContent);
      var absMax = numberFrom(ticks[ticks.length - 1].textContent);
      if (!isFinite(absMin) || !isFinite(absMax) || absMax <= absMin) return;

      /* Snize's hidden "min,max" model is the first choice, but it isn't
         always populated: with a price filter already applied on load it
         comes back as the literal string "NaN,NaN" (reproduced live in the
         mobile drawer), and its own slider then collapses both thumbs onto
         left:0. The two visible number inputs still hold the real values in
         that state, so they're the fallback, and the absolute bounds are
         the last resort. */
      var parts = String(hidden.value || '').split(',');
      var curMin = numberFrom(parts[0]);
      var curMax = numberFrom(parts[1]);

      if (!isFinite(curMin) || !isFinite(curMax)) {
        var minInput = slider.parentNode && slider.parentNode.querySelector('.snize-range-min-price');
        var maxInput = slider.parentNode && slider.parentNode.querySelector('.snize-range-max-price');
        curMin = numberFrom(minInput && minInput.value);
        curMax = numberFrom(maxInput && maxInput.value);
      }
      if (!isFinite(curMin)) curMin = absMin;
      if (!isFinite(curMax)) curMax = absMax;
      if (curMax < curMin) return;

      var width = back.clientWidth;
      var thumb = low.offsetWidth || 20;
      var travel = width - thumb;
      if (travel <= 0) return;

      var ratio = function (value) {
        return Math.min(1, Math.max(0, (value - absMin) / (absMax - absMin)));
      };
      var lowX = Math.round(ratio(curMin) * travel);
      var highX = Math.round(ratio(curMax) * travel);

      /* Keep Snize's own inline width in step with the rendered one too, so
         anything of theirs that reads it back agrees with what's on screen. */
      var container = slider.querySelector('.slider-container');
      if (container && container.style.width !== width + 'px') container.style.width = width + 'px';

      if (low.style.left !== lowX + 'px') low.style.left = lowX + 'px';
      if (high.style.left !== highX + 'px') high.style.left = highX + 'px';
      selected.style.left = (lowX + thumb / 2) + 'px';
      selected.style.width = Math.max(0, highX - lowX) + 'px';
    });
  }

  /* ── Mobile drawer: sections open on entry ────────────────────────────── */
  /* Snize's modal starts every accordion collapsed; the collections drawer
     this one is meant to match (and Figma) shows them expanded, so the user
     lands on the filters themselves rather than five closed rows. Fired
     once per opening — the flag is cleared again when the drawer closes. */
  var MOBILE_OPEN_ON_ENTRY = ['collections', 'stock_status', 'price', 'product_type'];

  function openMobileFilterSections() {
    var dialog = document.getElementById('snize-modal-mobile-filters-dialog');
    if (!dialog) return;

    if (getComputedStyle(dialog).display === 'none') {
      dialog.removeAttribute('data-bc-sections-opened');
      return;
    }
    if (dialog.hasAttribute('data-bc-sections-opened')) return;
    dialog.setAttribute('data-bc-sections-opened', '');

    MOBILE_OPEN_ON_ENTRY.forEach(function (key) {
      var header = document.getElementById('snize_product_filter_header_' + key);
      if (header && header.className.indexOf('open') === -1) header.click();
    });
  }

  /* Figma (node 102:20432 desktop / 102:21076 mobile) puts the tabs and
     "Showing N results for X" text on one row, tabs left / count right.
     In Snize's own DOM these are unrelated branches — .snize-main-panel-
     controls (tabs) and .snize-search-results-header (count text, nested
     inside the cream Filter/Sort bar) don't share a parent CSS could ever
     use to lay them out together — so the count text is physically moved
     to become a sibling of the tab links; bc-search-snize.css positions it
     from there with margin-left:auto.

     Snize only ever BUILDS .snize-search-results-header once, on the
     initial results render for a query — confirmed live: switching to
     Categories/Pages removes it from the DOM entirely (not just hidden),
     and switching back to Products via a client-side tab click does NOT
     rebuild it — the element is gone for the rest of that page load,
     Snize only creates it again on an actual full navigation/reload.
     Figma's count line is on all three tabs regardless, so a synthetic
     one is built here whenever the real one is missing, from the same
     tab-total badge getTabResultCount() reads for pagination — this ends
     up covering Categories/Pages every time and Products too on any tab
     switch after the first. data-bc-synthetic marks it so this function
     can always tell "Snize's real element" from "ours" — needed to clean
     the synthetic one up on the rare case Snize's own element reappears and
     would otherwise sit alongside a stale leftover from Categories/Pages. */
  var lastSyntheticCountText = null;

  function moveResultsCountNextToTabs() {
    var controls = document.querySelector('.snize-main-panel-controls');
    if (!controls) return;

    var real = document.querySelector('.snize-search-results-header:not([data-bc-synthetic])');
    var synthetic = controls.querySelector('.snize-search-results-header[data-bc-synthetic]');

    if (real) {
      if (synthetic) {
        synthetic.remove();
        lastSyntheticCountText = null;
      }
      if (real.parentElement !== controls) controls.appendChild(real);
      return;
    }

    var total = getTabResultCount();
    var q = new URLSearchParams(location.search).get('q');
    /* « » guillemets (not Snize's own straight quotes on Products, and
       "results"/no trailing count word rather than Products' exact
       wording) — a deliberate, Figma-matched divergence from the real
       Products-tab text, not an oversight; unifying the two would mean
       rewriting Snize's own markup on the tab that already works, out of
       scope here. */
    var text = q
      ? 'Showing ' + total + ' results for «' + q + '»'
      : 'Showing ' + total + ' results';

    /* Idempotent write — same reasoning as updatePaginationInfo(): writing
       on every runLayoutFixes() tick regardless of change would re-trigger
       the MutationObserver that calls runLayoutFixes(), looping. */
    if (text === lastSyntheticCountText && synthetic) return;

    if (!synthetic) {
      synthetic = document.createElement('div');
      synthetic.className = 'snize-search-results-header';
      synthetic.setAttribute('data-bc-synthetic', 'true');
      synthetic.setAttribute('aria-live', 'polite');
      controls.appendChild(synthetic);
    }
    synthetic.textContent = text;
    lastSyntheticCountText = text;
  }

  /* Snize's own mobile stylesheet (items_multicolumn_light_new.mobile*.css,
     served from their CDN — CORS-blocked, can't be read or out-specified
     from our stylesheet) sets box-sizing:content-box on the tab links and
     their <ul>, so bc-search-snize.css's explicit padding/height gets
     ADDED on top instead of included in it (confirmed live: a 60px-tall
     tab with 12px top/bottom padding rendered 84px tall). No CSS selector
     — not even one deliberately built more specific than theirs — won
     against it; only an inline style with !important reliably beats an
     external stylesheet's !important rule, so that's what this patches. */
  /* Mobile/tablet only (≤989px, matching bc-search-snize.css's own
     breakpoint for this row) — confirmed live this was a regression on
     desktop: Snize's DESKTOP stylesheet (a different file from the mobile
     one this fix targets) also sets box-sizing:content-box on these same
     classes, but paired with ITS OWN height:27px underline-tab styling,
     not the mobile 60px pill layout. Forcing border-box unconditionally
     made desktop tabs collapse to 28px instead of the intended 60px —
     this function running on every viewport, not just mobile, was the
     bug. */
  function fixTabBoxSizing() {
    var els = document.querySelectorAll(
      '.snize-main-panel-controls ul, ' +
      '.snize-main-panel-controls-products, ' +
      '.snize-main-panel-controls-categories, ' +
      '.snize-main-panel-controls-pages'
    );
    if (window.innerWidth > 989) {
      // Undo it if a live resize (no reload) crossed back to desktop after
      // this ran once at mobile width — otherwise the inline style set
      // below would just sit there forever, still winning.
      els.forEach(function (el) {
        if (el.style.boxSizing) el.style.removeProperty('box-sizing');
      });
      return;
    }
    els.forEach(function (el) {
      if (el.style.boxSizing !== 'border-box') {
        el.style.setProperty('box-sizing', 'border-box', 'important');
      }
    });
  }

  /* Snize sets display:none directly on .snize-main-panel-dropdown (the
     Sort trigger's wrapper) in "mobile design" mode — confirmed live by
     walking its ancestor chain, every ancestor visible, only this one
     element display:none. Figma's mobile row (102:21072) shows this
     trigger inline on the page at all times, not hidden inside the
     Filters modal, so this isn't a closed/collapsed state to leave alone
     — force it open. Same inline-style-!important approach as the
     box-sizing fix above, for the same reason (their rule isn't in a
     stylesheet we can out-specify — this is an inline style Snize's own
     JS sets directly on the element, which only an inline style can
     beat). */
  function fixDropdownVisibility() {
    var dd = document.querySelector('.snize-main-panel-dropdown');
    if (!dd) return;
    if (window.innerWidth > 989) {
      if (dd.style.display) dd.style.removeProperty('display');
      return;
    }
    if (getComputedStyle(dd).display === 'none') {
      dd.style.setProperty('display', 'flex', 'important');
    }
  }

  /* Reorders the filter blocks to Collections → Availability → Price →
     Product type (the order Figma 102:20443 wants), on both the desktop
     sidebar and the mobile "Filters" modal. This can't be done in CSS:
     the desktop sidebar's width is measured by Snize's own JS from its
     rendered (float-based) box, and switching it to flex/grid so CSS
     `order` would work desynced that measurement and broke the whole
     2-column layout (proven earlier in this project) — so the blocks are
     physically moved in the DOM instead.
     Desktop: each filter is a single .snize-product-filters-block element,
     id snize_filters_block_<key>, a direct child of the sidebar.
     Mobile modal: each filter is a *pair* of elements — a header
     (snize_product_filter_header_<key>) and a container
     (snize_product_filter_<key>) — both direct children of
     .snize-modal-content. "Sort by" is left in its natural first position
     (it isn't one of the four category filters the user asked to reorder);
     the four are moved as a group to sit right after it and before the
     Reset/Done buttons row. Vendor/Tags/Discount stay hidden (see CSS) so
     their position doesn't matter and is left untouched.
     Idempotent by design (checked against current order before touching
     the DOM) since this runs on the same 500ms poll as the other fixes. */
  var FILTER_ORDER = ['collections', 'stock_status', 'price', 'product_type'];

  function reorderFilterBlocks() {
    var sidebar = document.querySelector('.snize-filters-sidebar.snize-product-filters');
    if (sidebar) {
      var blocks = [];
      for (var i = 0; i < FILTER_ORDER.length; i++) {
        var block = document.getElementById('snize_filters_block_' + FILTER_ORDER[i]);
        if (block) blocks.push(block);
      }
      if (blocks.length === FILTER_ORDER.length) {
        var current = [];
        for (var j = 0; j < sidebar.children.length; j++) {
          var childId = sidebar.children[j].id;
          if (childId && childId.indexOf('snize_filters_block_') === 0 && FILTER_ORDER.indexOf(childId.replace('snize_filters_block_', '')) !== -1) {
            current.push(childId);
          }
        }
        var desired = blocks.map(function (b) { return b.id; });
        var same = current.length === desired.length && current.every(function (id, idx) { return id === desired[idx]; });
        if (!same) {
          blocks.forEach(function (b) { sidebar.appendChild(b); });
        }
      }

      /* "Remove all filters" (.snize-filters-title, wrapping
         .snize-selected-filters) — only in the DOM while a filter is
         active (confirmed live; it has no id, only this class — an
         earlier version of this function mistakenly looked it up by id
         and silently never matched). Figma puts it directly under
         Collections, above Availability; move it there whenever it
         exists. */
      var filtersTitle = sidebar.querySelector(':scope > .snize-filters-title');
      var stockBlock = document.getElementById('snize_filters_block_stock_status');
      if (filtersTitle && stockBlock && filtersTitle.nextElementSibling !== stockBlock) {
        sidebar.insertBefore(filtersTitle, stockBlock);
      }
    }

    var modalContent = document.querySelector('#snize-modal-mobile-filters-dialog .snize-modal-content');
    if (modalContent) {
      var buttonsContainer = modalContent.querySelector('.snize-product-filters-buttons-container');
      var pairs = [];
      for (var k = 0; k < FILTER_ORDER.length; k++) {
        var header = document.getElementById('snize_product_filter_header_' + FILTER_ORDER[k]);
        var container = document.getElementById('snize_product_filter_' + FILTER_ORDER[k]);
        if (header && container) pairs.push({ header: header, container: container });
      }
      if (buttonsContainer && pairs.length === FILTER_ORDER.length) {
        var currentSeq = [];
        for (var m = 0; m < modalContent.children.length; m++) {
          var elId = modalContent.children[m].id;
          for (var n = 0; n < FILTER_ORDER.length; n++) {
            if (elId === 'snize_product_filter_header_' + FILTER_ORDER[n] || elId === 'snize_product_filter_' + FILTER_ORDER[n]) {
              currentSeq.push(elId);
            }
          }
        }
        var desiredSeq = [];
        pairs.forEach(function (p) { desiredSeq.push(p.header.id, p.container.id); });
        var sameSeq = currentSeq.length === desiredSeq.length && currentSeq.every(function (id, idx) { return id === desiredSeq[idx]; });
        if (!sameSeq) {
          pairs.forEach(function (p) {
            modalContent.insertBefore(p.header, buttonsContainer);
            modalContent.insertBefore(p.container, buttonsContainer);
          });
        }
      }
    }
  }

  /* Returns the total result count for the currently-active search tab,
     read from Snize's own count badge inside the tab link — e.g.
     <span class="snize-products-tab-total">179</span> → 179. */
  function getTabResultCount() {
    var root = document.querySelector('#snize_results');
    var key = 'products';
    if (root) {
      if (root.classList.contains('snize-tab-selected-categories')) key = 'categories';
      else if (root.classList.contains('snize-tab-selected-pages')) key = 'pages';
    }
    var badge = document.querySelector('.snize-' + key + '-tab-total');
    if (badge) return parseInt(badge.textContent.replace(/[^\d]/g, ''), 10) || 0;
    var link = document.querySelector('.snize-main-panel-controls-' + key);
    if (!link) return 0;
    var m = link.textContent.match(/\d+/);
    return m ? parseInt(m[0], 10) : 0;
  }

  /* Items actually rendered on the current page — read directly instead of
     dividing totalResults by totalPages, which only happens to be correct
     when every page (including the last) is exactly full. A search with,
     say, 31 results over 3 pages of 15 would divide to ceil(31/3)=11 and
     mislabel every range; counting the live page is exact regardless. */
  function getCurrentPageItemCount() {
    var content = document.querySelector(RESULTS_SELECTOR);
    if (!content) return 0;
    return content.querySelectorAll(':scope > li').length;
  }

  /* Replaces Snize's numbered-pill pagination with the Figma design
     (102:20397 desktop / 102:21294 mobile), identical on all three tabs —
     ONE flex column, 12px gap, 200px wide, centered:
       1. "Showing X-Y of Z total" count line
       2. Progress bar (#F4EAE1 track / #CB9A71 fill)
       3. Snize's own numbered pills + Previous/Next, restyled (not hidden)

     Two failure modes from an earlier version, both addressed here:

     - Non-idempotent writes. Writing textContent/style.width on every
       runLayoutFixes() tick — even when the value hadn't changed — mutated
       the DOM, which re-triggered the MutationObserver that calls
       runLayoutFixes(), which wrote again. Measured live: 6 DOM writes for
       a single page change. Fixed by tracking the last-written text/width
       in module-level vars and skipping the DOM write entirely when the
       newly-computed value matches what's already there.

     - Where to put .bc-pag-wrap (count text + bar) relative to
       .snize-pagination. An earlier version kept them as two SEPARATE grid
       rows ("pag-info" / "pagination") specifically to avoid Snize's
       periodic rebuild of .snize-pagination's children (confirmed live via
       MutationObserver: a childList mutation ON .snize-pagination itself,
       -3/+1, wipes everything injected INSIDE it) — but two grid rows means
       the grid's own row-gap (28px desktop / 12px mobile) sits between
       them, not the design's 12px, and CSS Grid has no per-pair gap
       override. Fixed here by re-parenting .snize-pagination ONCE, as a
       whole element, into a new .bc-pag-container flex column alongside
       .bc-pag-wrap — safe because Snize's rebuild only ever replaces
       .snize-pagination's CHILDREN (confirmed above), never removes or
       re-parents .snize-pagination itself, so this re-parenting sticks
       permanently once done. If Snize ever DOES fully replace the
       .snize-pagination element (e.g. on a tab switch), the freshly
       queried element's parent is back to being #snize_results — the
       `!container` branch below detects that and re-wraps it the same
       way, so this self-heals either kind of rebuild. */
  var lastPagInfoText = null;
  var lastPagFillWidth = null;

  function updatePaginationInfo() {
    var pag = document.querySelector('.snize-pagination');
    if (!pag || !pag.parentElement) return;

    var activeLink = pag.querySelector('a.active[rev]');
    var currentPage = activeLink ? (parseInt(activeLink.getAttribute('rev'), 10) || 1) : 1;

    var totalPages = 1;
    pag.querySelectorAll('a[rev]:not(.snize-pagination-next)').forEach(function (a) {
      var n = parseInt(a.getAttribute('rev'), 10);
      if (n > totalPages) totalPages = n;
    });

    var totalResults = getTabResultCount();
    var pageItems = getCurrentPageItemCount();

    /* Derived from the live page rather than by dividing totalResults by
       totalPages — that division is only correct when every page is exactly
       full, and it isn't: Categories serves 20/page (30 results over 2
       pages) where ceil(30/2) would say 15.

       Split by whether this is the last page, because the last page is the
       one page whose item count is NOT the items-per-page value:
       - Not last: this page is full, so its own count IS items-per-page and
         start/end follow directly from it.
       - Last: its count is the remainder, so items-per-page is unknowable
         from here — but it isn't needed, since `end` is simply totalResults
         and `start` counts back from it by the remainder.
       This needs no cross-render cache (a cache would go stale on a tab
       switch, where items-per-page differs: 15 Products vs 20 Categories)
       and no division at all. */
    var start, end;
    if (currentPage >= totalPages) {
      end = totalResults;
      start = pageItems > 0 ? totalResults - pageItems + 1 : 1;
    } else {
      var perPage = pageItems || Math.ceil(totalResults / totalPages) || 15;
      start = (currentPage - 1) * perPage + 1;
      end = Math.min(currentPage * perPage, totalResults);
    }
    var progressPct = totalPages > 1 ? (currentPage / totalPages) * 100 : 100;

    /* Skip entirely until the inputs are coherent — writing a value built
       from a mid-render, half-updated DOM (e.g. totalResults still 0 while
       activeLink already points at the new page) would flash a wrong
       number and, per the idempotency guard below, get "stuck" looking
       stable until the next real change happens to differ from it too. */
    if (totalResults <= 0 || !currentPage) return;

    var container = pag.parentElement.classList.contains('bc-pag-container')
      ? pag.parentElement
      : null;

    if (!container) {
      container = document.createElement('div');
      container.className = 'bc-pag-container';
      pag.parentElement.insertBefore(container, pag);

      var wrap = document.createElement('div');
      wrap.className = 'bc-pag-wrap';
      wrap.innerHTML =
        '<div class="bc-pag-info"></div>' +
        '<div class="bc-pag-bar-wrap"><div class="bc-pag-bar-fill"></div></div>';

      /* Append in document order: text+bar first, then the real
         .snize-pagination element (moved here, not cloned — its own
         event listeners and Snize-internal references stay intact). */
      container.appendChild(wrap);
      container.appendChild(pag);
      lastPagInfoText = null;
      lastPagFillWidth = null;
    }

    var text = 'Showing ' + start + '-' + end + ' of ' + totalResults + ' total';
    if (text !== lastPagInfoText) {
      var info = container.querySelector('.bc-pag-info');
      if (info) info.textContent = text;
      lastPagInfoText = text;
    }

    var widthPct = progressPct.toFixed(2) + '%';
    if (widthPct !== lastPagFillWidth) {
      var fill = container.querySelector('.bc-pag-bar-fill');
      if (fill) fill.style.width = widthPct;
      lastPagFillWidth = widthPct;
    }
  }

  /* Categories/Pages row thumbnails — Snize's own search index was
     confirmed live to carry stale CDN URLs for a large share of Pages
     results (70% 404s measured on a sample search: an article's featured
     image gets re-uploaded, the URL's hash changes, Snize's index still
     points at the old one). A broken <img> renders as a bare glyph inside
     our 160/120px thumbnail box — hiding the whole thumbnail slot and
     letting the text column take the row alone reads far better than that
     glyph, and costs nothing when the image is fine.

     data-bc-thumb-checked marks an <img> once its outcome is known so this
     never re-attaches a second `error` listener or re-runs the already-
     failed check on a later runLayoutFixes() tick — this file's usual
     idempotency pattern (see data-bc-transformed on product cards). */
  function fixBrokenThumbnails() {
    var imgs = document.querySelectorAll(
      '#snize_results.snize-tab-selected-categories li.snize-category .snize-thumbnail img:not([data-bc-thumb-checked]),' +
      '#snize_results.snize-tab-selected-pages li.snize-page .snize-thumbnail img:not([data-bc-thumb-checked])'
    );
    imgs.forEach(function (img) {
      img.setAttribute('data-bc-thumb-checked', 'true');

      /* Covers an image whose `error` event already fired before this
         function ever saw it (e.g. it was already in the DOM, broken, on
         the very first runLayoutFixes() pass) — `complete` is true and
         `naturalWidth` stays 0 for a failed load, the same signal used
         elsewhere in this file (getCurrentPageItemCount's neighbors) to
         distinguish "loaded" from "errored" without re-triggering a
         fetch. */
      if (img.complete && img.naturalWidth === 0) {
        var thumb = img.closest('.snize-thumbnail');
        if (thumb) thumb.classList.add('bc-thumb-broken');
        return;
      }

      img.addEventListener('error', function () {
        var thumb = img.closest('.snize-thumbnail');
        if (thumb) thumb.classList.add('bc-thumb-broken');
      }, { once: true });
    });
  }

  function runLayoutFixes() {
    transform();
    moveResultsCountNextToTabs();
    fixTabBoxSizing();
    fixDropdownVisibility();
    reorderFilterBlocks();
    fixPriceSliderGeometry();
    openMobileFilterSections();
    updatePaginationInfo();
    fixBrokenThumbnails();
  }

  /* A MutationObserver bound to #snize_results turned out unreliable —
     Snize tears down and rebuilds significant parts of its own DOM tree
     during its async render pipeline (going from "loading" to real
     results), which can replace the very node an observer is bound to,
     silently orphaning it. Observing document.body instead survives that,
     and coalescing to one pass per animation frame keeps the cost to a
     handful of querySelectorAll calls per burst of Snize mutations.
     This used to be a bare 500ms interval, which meant every re-render
     (price change, filter, sort, paging) showed Snize's own layout for up
     to half a second before ours replaced it — the visible "jump". The
     interval is kept purely as a safety net for anything that changes
     without mutating the DOM (Snize re-applying inline styles in place).
     Our own writes re-enter this once and then converge: every fix is
     idempotent and no-ops on the second pass. */
  var framePending = false;

  /* rAF alone isn't enough: it doesn't fire while the tab is hidden or
     otherwise not compositing, which would strand a re-render behind the
     500ms interval again. Both are armed and whichever lands first wins —
     the flag makes the loser a no-op. */
  function scheduleLayoutFixes() {
    if (framePending) return;
    framePending = true;

    var run = function () {
      if (!framePending) return;
      framePending = false;
      runLayoutFixes();
    };

    requestAnimationFrame(run);
    setTimeout(run, 0);
  }

  /* The full pass is deferred to the next frame, but the reveal gate can't
     be: Snize inserts its cards and the browser would paint them in the
     same frame, which is exactly the flash this is here to stop. Marking
     the container is two selector calls, cheap enough to do synchronously
     inside the observer, before any paint. */
  function holdIfUntransformed() {
    var results = document.querySelector(RESULTS_SELECTOR);
    if (!results) return;
    if (results.querySelector('.snize-product:not([data-bc-transformed])')) {
      holdResults(results);
    }
  }

  new MutationObserver(function () {
    holdIfUntransformed();
    scheduleLayoutFixes();
  }).observe(document.body, { childList: true, subtree: true });

  window.addEventListener('resize', scheduleLayoutFixes);

  setInterval(runLayoutFixes, 500);
  runLayoutFixes();
})();
